import { BehaviorContext } from '../behavior-context';
import { Behavior } from '../behavior';
import { Injectable } from '@angular/core';

// export async function setLoadingStateActive(context: BehaviorContext<any>) {
//   const model = context.targetModel;
//   model.loading = true;
// }

@Injectable()
export class SetLoadingStateActive implements Behavior {
  async execute(args: any, context: BehaviorContext): Promise<any> {
    if (context.target.model) {
      context.target.model.loading = true;
    }
  }
}
